import { createEffect } from '../utils/create-effect';

export interface ClearCellsEffectDeps {
  /**
   * Mode-aware resolver: returns entry/field IDs for the current selection,
   * expanding row selections to all visible entries and column selections to
   * all visible fields.
   */
  resolveSelectionToIds: () => { entryIds: string[]; fieldIds: string[] };
  onClearValues: (entryIds: string[], fieldIds: string[]) => void;
}

export const createClearCellsEffect = createEffect(
  ({ resolveSelectionToIds, onClearValues }: ClearCellsEffectDeps) => {
    return {
      deltaTypes: ['clearCellsRequested'],

      onDelta(_delta, _state) {
        const { entryIds, fieldIds } = resolveSelectionToIds();

        // Both empty means nothing is selected.
        if (entryIds.length === 0 && fieldIds.length === 0) {
          return;
        }

        onClearValues(entryIds, fieldIds);
      }
    };
  }
);
